// !!! client-side component
import clsx from "clsx";
import FadeTransition from "components/FadeTransition";
import EPModal from "components/UI/EPModal";
import React, { useState } from "react";
import { isShareSupported } from "utils/index";
import {
  FaFacebookF,
  FaReddit,
  FaTwitter,
  FaWhatsapp,
  FaTelegram,
} from "react-icons/fa";
import { cn } from "utils/styling";
import EPButton from "components/UI/EPButton";
import { epToast } from "utils/epToast";
import { IoShareSocialOutline } from "react-icons/io5";
function ShareDialog({ title, text, path }) {
  const [isOpen, setIsOpen] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(`${window.location.origin + path}`);
    epToast.success(
      {
        title: "Link Copied!",
        description: `${window.location.origin + path}`,
      },
      {
        id: "shared",
      }
    );
  }
  return (
    <>
      <FadeTransition>
        <button
          aria-label="share game"
          variant="icon"
          onClick={() => {
            isShareSupported()
              ? window.navigator
                  .share({
                    title: title,
                    text: text,
                    url: `${window.location.origin + path}`,
                  })
                  .then(() => {
                    epToast.success(
                      {
                        title: "Link Shared!",
                        description: `${window.location.origin + path}`,
                      },
                      {
                        id: "shared",
                      }
                    );
                  })
                  .catch(() => {})
              : setIsOpen(true);
          }}
          className={clsx(
            "flex aspect-square w-full items-center justify-center gap-2 rounded-full bg-transparent text-white hover:bg-primary-content/50 active:bg-primary-content/70"
          )}
        >
          {" "}
          <IoShareSocialOutline alt="copy" size={24} />
        </button>
      </FadeTransition>
      <EPModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <div className="flex flex-col gap-2">
          <span className="text-start text-sm font-medium">
            Share this link via
          </span>
          <div className="flex auto-cols-[1fr] flex-wrap items-center  justify-center gap-2 md:mt-2">
            <ShareIcon
              icon={<FaFacebookF />}
              title={"Facebook"}
              iconClassName="bg-[#4267b2]"
              onClick={() => {
                window.open(
                  `https://www.facebook.com/sharer/sharer.php?u=${
                    window.location.origin + path
                  }`,
                  "_blank"
                );
              }}
            />
            <ShareIcon
              icon={<FaTwitter />}
              title={"Twitter"}
              iconClassName="bg-[#1da1f2]"
              onClick={() => {
                window.open(
                  `https://twitter.com/intent/tweet?text=${
                    window.location.origin + path
                  }`,
                  "_blank"
                );
              }}
            />
            <ShareIcon
              icon={<FaReddit />}
              title={"Reddit"}
              iconClassName="bg-[#ff4500]"
              onClick={() => {
                window.open(
                  `https://www.reddit.com/submit?url=${
                    window.location.origin + path
                  }`,
                  "_blank"
                );
              }}
            />
            <ShareIcon
              icon={<FaWhatsapp />}
              title={"Whatsapp"}
              iconClassName="bg-[#25d366]"
              onClick={() => {
                window.open(
                  `https://api.whatsapp.com/send?text=${
                    window.location.origin + path
                  }`,
                  "_blank"
                );
              }}
            />
            <ShareIcon
              icon={<FaTelegram />}
              title={"Telegram"}
              iconClassName="bg-[#0088cc]"
              onClick={() => {
                window.open(
                  `https://t.me/share/url?url=${window.location.origin + path}`,
                  "_blank"
                );
              }}
            />
          </div>
        </div>
        <div className="mt-4 flex flex-col gap-2">
          <span className="text-start text-sm font-medium">Page Link</span>
          <div className="flex cursor-pointer flex-col gap-2 rounded-lg  pl-4 pr-2 md:flex-row md:items-center md:justify-between md:bg-black/50">
            <div
              onClick={handleCopy}
              className="flex-1 break-all rounded-lg bg-black/50 py-2 pl-4 pr-2 text-start  text-gray-200  sm:text-sm  md:bg-transparent"
            >
              {`${window.location.origin + path}`}
            </div>
            <EPButton
              variant="primary"
              className="my-2 w-full rounded-full text-sm md:w-auto"
              onClick={handleCopy}
            >
              Copy
            </EPButton>
          </div>
        </div>
      </EPModal>
    </>
  );
}

export default ShareDialog;

function ShareIcon({ icon, title, onClick, iconClassName = "" }) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded active:bg-primary-content/10 md:p-2"
      )}
    >
      <span
        className={cn(
          "flex h-10 w-10 items-center justify-center rounded-full text-xl md:h-14 md:w-14 md:text-2xl",
          iconClassName
        )}
      >
        {icon}
      </span>
      <span className="hidden text-xs md:inline">{title}</span>
    </button>
  );
}
